<div class="menu flowchart-context-menu_context">
    <ul class="menu-options_context">
      <li (click)="openChartDialog(selected_series.attributes.name)" class="menu-option_context">Show chart</li>
      <li (click)="editSeries(selected_series)" class="menu-option_context">Edit series</li>
      <li (click)="updateCalculations(selected_series)" class="menu-option_context">Update calculations</li>
      <li (click)="refreshSeries()" class="menu-option_context">Refresh series</li>
    </ul>
</div>
